<template>
  <Modal name="DELETE_REAL_ESTATE_USER_MODAL" title="Remover">
    <template v-slot:body>
      <div v-if="showContent">
        <p class="mb-2">{{ $t('realEstateUsers.hint.deleteUser') }}</p>

        <v-card class="pa-5 mt-5 mb-8 grey lighten-3" outlined>
          <p class="body-2 mb-0">
            {{ realEstateUser.name }}
          </p>
          <p class="caption grey--text text--darken-1 mb-0">
            {{ realEstateUser.username }}
          </p>
        </v-card>

        <div class="d-flex justify-end gap-1">
          <v-btn @click="closeAllModals" text>
            {{ $t('realEstateUsers.label.cancel') }}
          </v-btn>
          <v-btn @click="deleteRealEstateUser(realEstateUserId)" class="red" dark text>
            {{ $t('realEstateUsers.label.remove') }}
          </v-btn>
        </div>
      </div>

      <v-progress-linear v-else indeterminate />
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'RealEstateUserDelete',
  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['isRealEstateUserLoading', 'realEstateUser', 'realEstateUserId']),

    showContent() {
      return !this.isRealEstateUserLoading && this.realEstateUser
    },
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['deleteRealEstateUser']),
  },
}
</script>
